{
	"letterhead": "Evento '{{name}} ({{begin}})'",
	"notAuthorized": "Você não está autorizado a ver nenhum relatório dessa seção"
}
